import { Injectable } from '@angular/core';
import { CheckinForm } from '@com-delta-idp/mnx-capability-trip-management-ui';
import {
  AppConfigService,
  HttpRequestMethods
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  FORM_TARGET,
  IDP_APP,
  MyTripEndpointKeys
} from '../models/enums/my-trip.enums';
import { GenericFormFields } from '../models/interface/generic-form.interface';

@Injectable({
  providedIn: 'root'
})
export class CheckInService {
  loadCheckinForm = false;
  checkinPath!: string;
  checkinFormFields: GenericFormFields = {
    fieldItem: [],
    action: '',
    target: '',
    method: HttpRequestMethods.POST
  } as GenericFormFields;

  constructor(private appConfig: AppConfigService) {
    this.appConfig
      .getConfigValue(IDP_APP.MY_TRIPS, MyTripEndpointKeys.CHECK_IN_AWS_URL)
      .subscribe((value: string) => {
        this.checkinPath = value;
      });
  }

  populateCheckInForm(checkinForm: CheckinForm): void {
    this.checkinFormFields.fieldItem = [];
    Object.entries(checkinForm).map(([key, value]) => {
      this.addFormField(key, value);
    });
    this.checkinFormFields.action = this.checkinPath;
    this.checkinFormFields.target = FORM_TARGET.self;
    this.checkinFormFields.method = HttpRequestMethods.POST;
  }

  addFormField(key: string, value: string | boolean): void {
    this.checkinFormFields.fieldItem.push({ key: key, value: value });
  }
}
